const mixin = {
  data: () => ({
    form: {},
    loading: true,
    error: false
  }),

  computed: {
    formRef () {
      return this.getFormRef()
    }
  },

  methods: {
    handleResponse ({ data }) {
      this.form = data
    },

    handleError () {
      this.error = true
    },

    handleFinally () {
      this.loading = false
      this.$nextTick(() => this.resetValidation())
    },

    readonlyLoad (attributes) {
      this.form = attributes
      this.loading = false
    },

    // @vuese Método para validação da form
    validateForm () {
      return this.formRef.validate()
    },

    // @vuese Limpa validação dos campos
    resetValidation () {
      this.formRef.resetValidation()
    },

    getFormRef () {
      const formRef = this.$refs.form
      if (!formRef) throw Error('Form should have a ref called "form" in a form tag to implement validation features')
      else return formRef
    }
  }
}

export default mixin
